// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exc-link[data-v-dbd45d90]{transition:all .2s}.exc-link--no-decoration[data-v-dbd45d90],.exc-link--no-decoration-active[data-v-dbd45d90]{text-decoration:none}.exc-link:not(.exc-link--no-decoration-active).router-link-active[data-v-dbd45d90],.exc-link:not(.exc-link--no-decoration-active).router-link-exact-active[data-v-dbd45d90]{color:#1c1d20;color:var(--c-main,#1c1d20)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
